import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchTagData, fetchThemeData } from '../../../../../actions/routines';
import qs from 'qs';
import history from '../../../../../history';
import * as R from 'ramda';
import { fetchProducts } from '../../../../../actions/masterTable';
import { fetchTheme } from '../../../../../actions/themes';

class TagInfoContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lastLoadedTagId: 0,
            currentTheme: undefined,
        };
    }

    componentDidMount() {
        const params = qs.parse(history.location.search.slice(1));

        if (params['s_tag']) {
            this.setState({ lastLoadedTagId: params['s_tag'] });
            this.props.fetchTagData(params['s_tag']);
        }

        if (params['s_theme']) {
            this.setState({ currentTheme: params['s_theme'] });

            this.props.fetchThemeData(params['s_theme']);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const params = qs.parse(history.location.search.slice(1));

        if (this.state.lastLoadedTagId !== params['s_tag'] && params['s_tag']) {
            this.setState({ lastLoadedTagId: params['s_tag'] });
            this.props.fetchTagData(params['s_tag']);
        }

        if (!params['s_tag'] && this.state.lastLoadedTagId) {
            this.setState({ lastLoadedTagId: 0 });
        }

        if (this.state.currentTheme !== params['s_theme']) {
            this.setState({ currentTheme: params['s_theme'] });

            if (params['s_theme']) {
                this.props.fetchThemeData(params['s_theme']);
            } else {
                this.setState({ currentTheme: undefined });
            }
        }
    }

    handlerClearSelectedTag = () => {
        const params = qs.parse(history.location.search.slice(1));
        delete params['s_tag'];

        this.setState({ lastLoadedTagId: 0 });

        history.push({
            ...history.location,
            search: qs.stringify(params),
        });

        if (!history.location.pathname.includes('products')) {
            history.push({ pathname: '/products' });
        } else {
            this.props.fetchProducts({ params });
        }
    };

    handlerClearSelectedTheme = () => {
        const params = qs.parse(history.location.search.slice(1));
        delete params['s_theme'];

        this.setState({ currentTheme: null });

        history.push({
            ...history.location,
            search: qs.stringify(params),
        });

        if (!history.location.pathname.includes('products')) {
            history.push({ pathname: '/products' });
        } else {
            this.props.fetchProducts({ params });
        }
    };

    render() {
        const { tag } = this.props;
        const { themeInfo } = this.props;
        const params = qs.parse(history.location.search.slice(1));

        if (
            (!tag ||
                parseInt(this.state.lastLoadedTagId) !== parseInt(tag.id)) &&
            !this.state.currentTheme
        ) {
            return <></>;
        }

        return (
            <div className="row">
                <div className="col mb-3 d-flex align-items-center flex-wrap tag-info-wrapper">
                    {tag && params && params['s_tag'] && (
                        <>
                            <span className="tag-context-text">
                                <FormattedMessage id="product_details.tags.the_tag" />
                            </span>
                            <div className="tag-box">
                                <strong>{tag.name}</strong>
                                <span
                                    className="tag-close"
                                    onClick={this.handlerClearSelectedTag}
                                >
                                    ×
                                </span>
                            </div>
                        </>
                    )}
                    {tag &&
                        params['s_tag'] &&
                        themeInfo?.name &&
                        this.state.currentTheme && (
                            <span className="tag-context-text">
                                <FormattedMessage id="product_details.tags.in_theme" />
                            </span>
                        )}
                    {themeInfo?.name && this.state.currentTheme && (
                        <>
                            {!tag && (
                                <span className="tag-context-text">
                                    <FormattedMessage id="product_details.tags.the_theme" />
                                </span>
                            )}
                            <div className="tag-box">
                                <strong>{themeInfo?.name}</strong>
                                <span
                                    className="tag-close"
                                    onClick={this.handlerClearSelectedTheme}
                                >
                                    ×
                                </span>
                            </div>
                        </>
                    )}
                    <span className="tag-context-text">
                        <FormattedMessage id="product_details.tags.tag_context" />
                    </span>
                </div>
            </div>
        );
    }
}

TagInfoContainer.defaultProps = {
    tag: null,
};

TagInfoContainer.propTypes = {
    tagLoading: PropTypes.bool,
    fetchTagData: PropTypes.func,
    fetchProducts: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        tag: state.tag?.data,
        tagLoading: state.tag?.loading,
        themeInfo: state.themeInfo?.data,
    };
};
export default injectIntl(
    connect(mapStateToProps, { fetchTagData, fetchProducts, fetchThemeData })(
        TagInfoContainer
    )
);
